import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DoneIcon from '@mui/icons-material/Done';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import RoomRatesEditorRoomSettings from 'components/RoomRatesEditorRoomSettings';
import RoomRatesEditorCateringSettings from 'components/RoomRatesEditorCateringSettings';

import { RoomRatesEditorInit_package$key } from '__generated__/RoomRatesEditorInit_package.graphql';
import { RoomRatesEditorInit_data$key } from '__generated__/RoomRatesEditorInit_data.graphql';
import Dialog from 'components/Dialog';

type Props = {
  package: RoomRatesEditorInit_package$key;
  data: RoomRatesEditorInit_data$key;
};

const RoomRatesEditorInit: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment RoomRatesEditorInit_package on Package {
        cateringOptions {
          id
        }

        rooms {
          id
        }

        ...RoomRatesEditorRoomSettings_package
        ...RoomRatesEditorCateringSettings_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment RoomRatesEditorInit_data on Query {
        ...RoomRatesEditorCateringSettings_data
      }
    `,
    props.data
  );

  const { cateringOptions, rooms } = pack;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={{ mb: 2 }}>
        Kad suformuoti kainų lentelę, nurodykite šiuos parametrus
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Dialog
          fullWidth
          maxWidth="md"
          activateButton={open => (
            <Button
              color={rooms.length > 0 ? 'success' : 'primary'}
              variant="outlined"
              size="large"
              startIcon={
                rooms.length > 0 ? <DoneIcon /> : <RoomPreferencesIcon />
              }
              onClick={open}>
              Kambarių nustatymai
            </Button>
          )}>
          <RoomRatesEditorRoomSettings package={pack} />
        </Dialog>
      </Box>

      <Box>
        <Dialog
          fullWidth
          maxWidth="md"
          activateButton={open => (
            <Button
              color={cateringOptions.length > 0 ? 'success' : 'primary'}
              variant="outlined"
              size="large"
              startIcon={
                cateringOptions.length > 0 ? <DoneIcon /> : <LocalDiningIcon />
              }
              onClick={open}>
              Maitinimo nustatymai
            </Button>
          )}>
          <RoomRatesEditorCateringSettings package={pack} data={data} />
        </Dialog>
      </Box>
    </Box>
  );
};

export default RoomRatesEditorInit;
